<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title"><i class="fa fa-eye mr-5"></i>SAP</h3>
        <div class="box-tools pull-right">
          <button type="button" class="btn btn-box-tool" data-widget="collapse">
            <i class="fa fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="box-controls">
        <div class="row">
          <div class="col-xs-3">
            <select class="form-control" v-model="filter">
              <option class="normal" value="nothing">{{'Select_option' | translate}}</option>
              <option class="normal" value="failedShippingInbound">Shipping</option>
              <option class="normal" value="failedReturnInbound">Return</option>
              <option class="normal" value="failedReductionInbound">Reduction</option>
            </select>
          </div>
          <div class="col-xs-9">
            <my-pagination :lang="$store.getters.language" :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
          </div>
        </div>
      </div>
      <div class="box-body">
        <template v-if="loading && !this.init">
          <div class="row">
            <div class="col-xs-12 text-center">
              <img class="loading-gif" src="/static/img/blabla.svg"/>
            </div>
          </div>
        </template>
        <template v-else-if="this.init">
          <div class="row">
            <div class="col-xs-12 text-center">
              {{"Select_option" | translate}}
            </div>
          </div>
        </template>
        <template v-else-if="Object.keys(pagination.data).length > 0">
          <div id="accordion-test-2" class="panel-group joined">
            <div class="panel panel-default" v-for="(row, index) in pagination.data">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a :href="`#collapse-${index}`" data-parent="#accordion-test-2" data-toggle="collapse">{{row.sap_idoc_no}} - {{row.type}}</a>
                </h4>
              </div>
              <div :id="`collapse-${index}`" class="panel-collapse collapse in">
                <div class="panel-body">
                  <div :class="['col-xs-6', 'col-lg-4', isOld(row.inbound_date) ? 'text-danger' : '']">
                    <router-link :to="`/orders/${row.parent_order_id}`" target="_blank"><strong>{{'order_id' | translate}}: </strong> {{row.parent_order_id}}<i class="fa fa-external-link ml-5"></i></router-link><br/>
                    <strong>{{'merchant_article_number' | translate}}: </strong>{{row.ext_order_id}}<br/>
                    <strong>{{'inbound_date' | translate}}:</strong>
                    <span class="italic small">
                        <span v-if="row.inbound_date === null">
                          {{'no_inbound_date_given'| translate}}
                        </span>
                        <span v-else>
                          {{row.inbound_date | orderDateApi}} <i class="fa fa-clock-o mr-5"></i>{{row.inbound_date | orderDateApi(true)}}
                        </span>
                    </span><br/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="callout callout-info">
            <h4><i class="fa fa-exclamation-triangle mr-5"></i>Info</h4>
            <p>Aktuell liegen uns keine offenen Bestellungen die älter als 12 Stunden sind vor, die nicht versendet sind.</p>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>
<script>
  export default {
    data () {
      return {
        alerts: [],
        ready: [],
        rows: [],
        filter: 'nothing',
        loading: true,
        init: true,
        pagination: {
          total: 0,
          per_page: 25,
          current_page: 1,
          total_pages: 0
        }
      }
    },
    methods: {
      paginate (type, value) {
          if(this.filter!=='nothing') {
              this.loading = true
              let url = `monitoring/sap/problematicorders?filter=${this.filter}`
              if (type === 'page') {
                  url += '&page='
                  if (value === 'previous') {
                      url += (this.pagination.current_page - 1)
                  }
                  if (value === 'next') {
                      url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
                  } else if (value !== 'next' && value !== 'previous') {
                      url += value
                  }
              }
              API.get(url, {})
                  .then(response => {
                      this.pagination = response.data
                      this.loading = false
                      this.init=false;
                  })
                  .catch(error => {
                      this.$store.dispatch('checkError', error)
                  })
          }else{
              this.init=true;
          }
      },
      getData () {
          if(this.filter!=='nothing') {
              API.get(`monitoring/sap/problematicorders?filter=${this.filter}`, {})
                  .then(response => {
                      this.pagination = response.data
                      this.loading = false
                      this.init=false;
                  })
                  .catch(error => {
                      this.checkError(error)
                  })
          }else{
              this.init=true;
          }
      },
      isOld (date) {
        let d = moment(date, 'DD.MM.YYYY HH:mm:ss')
        return moment().diff(d, 'hours') > 32
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.getData()
      })
    },
    watch: {
      '$route.params' () {
        this.loading = true
        this.getData()
      },
      filter () {
        this.paginate('', '')
      }
    }
  }
</script>
<style>
  .date-popover {
    overflow-x: hidden;
    overflow-y: hidden;
    outline: none;
    max-width: 350px;
    width: 100%;
    border-radius: 0 0 .28571429rem .28571429rem;
    box-shadow: 0 2px 3px 0 rgba(34,36,38,.15);
    background: #212228 !important;
    transition: opacity .1s ease;
    position: relative;
    margin: auto;
    z-index: 10;
    border: 1px solid;
    font-size: 1rem;
    font-weight: 200;
  }
  .picker .monthItem .item.active:hover{
    border-top: 1px solid;
    cursor: pointer;
    background-color: rgba(0,195,150,.4) !important;
    border-color: rgba(0,195,150,1) !important;

  }
</style>
<style scoped>
  .panel {
    background-color: #282a31 !important;
  }
  .panel-heading {
    background-color: #212228 !important;
  }
  .img-responsive {
    display: inline !important;
    width: 16px !important;
  }
</style>
<style scoped>
  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }
  .italic {
    font-style: italic;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Overviews/SapOverview.vue